<template>
<div class="main">
    <!-- <div class="title">
        现场照片
    </div> -->
    <ul>
        <!-- <li v-for="(item,index) in images" :key="index" @click="previewImg(item)">
            <img :src="item" alt="">
        </li> -->
        <li>
            <img :src="imageUrl" alt="">
        </li>
    </ul>
</div>
</template>

<script>
import config from "@/common/env.js"

export default {
    name: 'images',
    data() {
        return {
            images: [],
            imageUrl: null,
        }
    },
    created() {
        let fileUrl = this.$route.query.fileUrl;
        this.imageUrl = this.getImageUrl(fileUrl);
    },
    mounted(){
        // this.getImgs();
    },
    methods: {
        previewImg(url) {
          let that=this;
            if(this.$store.state.previewImgUrl){
              this.$store.commit("SHOW_PREVIEW_IMG", '')
            }
            setTimeout(() => {
              that.$store.commit("SHOW_PREVIEW_IMG", url);
            }, 500);
        },
        getImageUrl(url, type) {
            let str = type ? "/file/server/file" : "/file/server/decrypt/file";
            return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
        },
        getImgs() {
            var that = this;
            var accidentId = this.$route.query.accidentId;
            this.$axios.post(`/rollback/accident/evidence/${accidentId}/evidences`).then(res => {
                let data = res.data;
                if (data.code === 0) {
                    console.log('data',data);
                    var infos=data.data;
                    if(infos.length){
                        infos.forEach(element => {
                            var https='https://'
                            https+=element.appendUrl;
                            that.images.push(that.getImageUrl(element.appendUrl));
                        });
                    }
                } else {
                    that.$message.error(data.msg);
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    height: 100%;

    .title {
        width: 100%;
        height: 40px;
        position: fixed;
        top: 0px;
        left: 0px;
        font-size: 40px;
        box-sizing: border-box;
        padding: 10px;
    }

    ul {
        width: 100%;
        height: 100%;
        display: flex;
        // flex-wrap: wrap;
        // align-items: flex-start;
        // justify-content: flex-start;
        align-items: center;

        li {
            width: 100%;
            // height: 100%;
            // padding: 10px;

            img {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// images.vue?015b3d5d